<div [class]="'chart-container relative h-[calc(100%-2rem)] w-full ' + id" [hidden]="!isDataPresent">
    <div class="relative h-full mt-8 min-w-[99%]" [ngClass]="['w-[' + chartData?.minWidth + 'px]', 'h-[' + chartData?.minHeight + 'px]']">
        <canvas [id]="id"></canvas>
    </div>
</div>
<ng-container *ngIf='!loading && !isDataPresent'>
    <div class="heightContainer">
        <p class="noDataFound d-flex justify-content-center" [class.mat-error]="widget?.errorMessage?.length > 0" *transloco="let translate" [textContent]="widget?.errorMessage || translate('No data found.')">
        </p>
    </div>
</ng-container>
<div class="loader d-flex justify-content-center widgetLoader" *ngIf='loading && !isFromEnCollab'>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
